import { createAction } from '@ngrx/store';
import { ActionCreator } from '@ngrx/store/src/models';

export type LoadSessionTokenAction = ActionCreator;

export class SessionTokenActions {

  static readonly sessionTokenLoaded =
    createAction(
      '[Session Token Feature] Session Token Loaded',
      (token: string) => ({ token }),
    );

  static readonly sessionTokenLoadFailed =
    createAction(
      '[Session Token Feature] Session Token Load Failed',
      (error?: string) => ({ error }),
    );

}
